// @ts-nocheck
import * as Sentry from '@sentry/vue';
import type { IAdapter } from '../event-client';
import type { EventPayloads, EventTypes, LoginPayload } from '../events';
import { onLoad } from '../utils';

const subscribedEvents: Array<EventTypes> = ['purchase'];

// interface TransformerResponse {
// 	name: string;
// 	data: Record<string, unknown>;
// }

class UpfTransformer {
	static transformPurchaseEvent(
		data: EventPayloads['purchase'],
	): TransformerResponse {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
		console.log('upfluence purchase event inside transformer', data);
		return {
			name: 'order',
			data: {
				order_id: data.transaction_id,
				order_name: data.orderNumber,
				amount: data.totalPrice,
				currency: data.currency,
				items: data.items,
				customer: {
					customer_id: data.userId,
					first_name: data.firstName,
					last_name: data.lastName,
					email: data.email,
				},
			},
		};
	}
}

const TransformerMap = {
	purchase: UpfTransformer.transformPurchaseEvent,
};

const loadUpfluence = async () => {
	await onLoad(async () => {
		const script = document.createElement('script');
		script.async = true;
		script.src =
			'https://tracking.upfluence.co/js/v1/init-9ae0871a-285f-4a2e-897d-cc728779dd1e.js';
		document.body.appendChild(script);

		await new Promise((resolve, reject) => {
			script.onload = () => {
				resolve(1);
			};
			script.onerror = (e) => {
				console.log('Failed to load upfluence script: script:on-error', e);
				Sentry.captureException('Failed to load upfluence script', (scope) => {
					scope.setContext('error', {
						message: e.toString(),
					});
					return scope;
				});
				script.remove();
				reject(1);
			};
		});
	});
};
export class UpfluenceAdapter implements IAdapter {
	name: string = 'upfluence';
	queue: Array<{ name: EventTypes; data: EventPayloads[EventTypes] }> = [];

	async init(): Promise<void> {
		let retry = 1;
		while (retry >= 0) {
			try {
				await loadUpfluence();
				break;
			} catch (e) {
				console.log('Failed to load upfluence script', e);
				retry--;
			}
		}

		this.queue.forEach((event) => {
			// @ts-ignore
			const { data, name } = TransformerMap[event.name]
				? // @ts-ignore
					TransformerMap[event.name](event.data)
				: { data: event.data, name: event.name };
			window._upf.push([name, data]);
		});
	}

	sendEvent<T extends EventTypes>(
		eventName: T,
		eventData: EventPayloads[T],
	): void {
		if (!subscribedEvents.includes(eventName)) {
			return;
		}
		if (!window._upf) {
			this.queue.push({ name: eventName, data: eventData });
			return;
		}
		// @ts-ignore
		this.queue.push({ name: eventName, data: eventData });

		this.queue.forEach((event) => {
			// @ts-ignore
			const { name, data } = TransformerMap[event.name]
				? // @ts-ignore
					TransformerMap[event.name](event.data)
				: { data: event.data, name: event.name };
			window._upf?.push([name, data]);
		});
	}
	login(_: LoginPayload): void {
		// Empty function
	}
	logout(): void {
		// Empty function
	}
}
